/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Noemailreceived2Inputs */

const zh_auth_noemailreceived2 = /** @type {(inputs: Auth_Noemailreceived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有收到邮件？请检查垃圾邮件文件夹或重试。`)
};

const en_auth_noemailreceived2 = /** @type {(inputs: Auth_Noemailreceived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didn't receive the email? Check your spam folder or try again.`)
};

const es_auth_noemailreceived2 = /** @type {(inputs: Auth_Noemailreceived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No recibiste el correo? Revisa tu carpeta de spam o inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Didn't receive the email? Check your spam folder or try again." |
*
* @param {Auth_Noemailreceived2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_noemailreceived2 = /** @type {((inputs?: Auth_Noemailreceived2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Noemailreceived2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_noemailreceived2(inputs)
	if (locale === "en") return en_auth_noemailreceived2(inputs)
	return es_auth_noemailreceived2(inputs)
});
export { auth_noemailreceived2 as "auth_noEmailReceived" }